import styled from 'styled-components';
import {
  space, color, flexbox, layout, border,
} from 'styled-system';


const Flex = styled.div(
  {
    display: 'flex',
  },
  space,
  flexbox,
  color,
  layout,
  border,
);
export default Flex;
